var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "process-container" },
    [
      _vm._l(_vm.steps, function(step, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "header-image",
            class: { active: index == _vm.selectedStepIndex },
            style: "background-image: url(" + step.header_image["url"] + ";"
          },
          [
            step.add_background_overlay
              ? _c("div", {
                  staticClass: "overlay",
                  style: { opacity: step.background_overlay_opacity }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "top-title" }, [
                _vm._v("Step " + _vm._s(index + 1))
              ]),
              _vm._v(" "),
              _c("h1", {
                staticClass: "title",
                domProps: { innerHTML: _vm._s(step.title) }
              })
            ])
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "steps-container" },
        [
          _c(
            "slick-carousel",
            {
              ref: "carousel",
              staticClass: "steps-carousel",
              attrs: { options: _vm.getCarouselOptions() },
              on: { afterChange: _vm.carouselChanged }
            },
            _vm._l(_vm.steps, function(step, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "step",
                  class: [
                    { active: index == _vm.selectedStepIndex },
                    { previous: index < _vm.selectedStepIndex }
                  ],
                  on: {
                    mouseenter: function($event) {
                      return _vm.setSelectedStep(index)
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "step-number",
                    domProps: { innerHTML: _vm._s(_vm.getStepNumber(index)) }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-container" }, [
                    _c("h2", {
                      staticClass: "title",
                      domProps: { innerHTML: _vm._s(step.title) }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "description",
                      domProps: { innerHTML: _vm._s(step.description) }
                    }),
                    _vm._v(" "),
                    step.button
                      ? _c("div", { staticClass: "button-container" }, [
                          _c("a", {
                            staticClass: "hover-button white",
                            attrs: {
                              href: step.button.url,
                              target: step.button.target
                            },
                            domProps: { innerHTML: _vm._s(step.button.title) }
                          })
                        ])
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }